import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries'

import HomeProc1 from './homeproc1';
import HomeProc2 from './homeproc2';

import ProcDX1 from './procdx1';
import ProcDX2 from './procdx2';
import ProcPagoTer1 from './procpagoter1';
import ProcPagoTer2 from './procpagoter2';
import ProcRdoTerc1 from './procrdoterc1';
import ProcRdoTerc2 from './procrdoterc2';
import ProcCAR1 from './proccar1';
import ProcCAR2 from './proccar2';

import ProcCliDX1 from './procclidx1';
import ProcCliDX2 from './procclidx2';
import VerCliDX1 from './verclidx1';
import VerCliDX2 from './verclidx2';

import ProcATOS1 from './procatos1';
import ProcATOS2 from './procatos2';

import ProcAT1 from './procat1';
import ProcAT2 from './procat2';
import ProcCS1 from './proccs1';
import ProcCS2 from './proccs2';
import ProcEC1 from './procec1';
import ProcEC2 from './procec2';

import ProcAdm1 from './procadm1';
import ProcAdm2 from './procadm2';
import ProcAdmCC from './procadmcc';
import ProcAdmCA from './procadmca';
import ProcAdmAjNeg from './procadmaj';
import ProcAdmAjPos from './procadmajpos';
import ProcAdmNC from './procadmnc';
import ProcAdmClNd from './procadmclnd';
import ProcAdmClNu from './procadmclnu';
import ProcAdmClUpd from './procadmclupd';
import ProcAdmOSDX from './procadmosdx';
import ProcAdmOSSC from './procadmossc';
import ProcAdmTC from './procadmtc';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

class HomeProc extends React.Component{
  state={
    showProc: true, showProcPagoTer: false, showProcRdoTerc: false, showProcCAR: false,
    showProcCliDX: false, verCliDX: false, showProcDX: false, showProcATOS: false,
    showProcAT: false, showProcCS: false, showProcEC: false,
    showProcAdm: false, showCambContr: false, showCliNu: false, showCliUpd: false, showOSDX: false,
    showOSSC: false, showTC: false, showArchNC: false, handleClickArchCarAdic: false,
    showArchAjNeg: false, showArchAjPos: false, showArchClNd: false,
    permiteUpdate: false, permiteDelete: false, permiteClose: false, argsAdd: {}, errorAdd: [], argsBuscCliente: {},
    idLista: {}, argsBuscar: {}
  }

  nextVal = async (name) => {
    const argsUpd = {
        coleccion: name,
      }
      const response = await this.props.editSeqfindOneAndUpdate({
        variables: argsUpd
      });
      return response.data.editSeqfindOneAndUpdate.seq
    }

    crudBD = async (operacionCRUD, args, i)=>{
      //ACTUALIZAR BD
      // console.log("CRUD")
            if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
              const {data} = await operacionCRUD({
                variables: args
              });
        
      //Se utiliza para traer el _id del documento creado
              if(args.ctrl_id === 'SI_ID'){
                if(Object.values(data)[0]._id){
                  return Object.values(data)[0]._id
                }else{
                  return 0
                }
              }
            }else{
              if(args.ctrlCampo === "MANY"){
                // console.log("MANY")
                // console.log(args)
                await operacionCRUD({
                  variables: args
                });
              }
            }
          }
            
          updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
        //ENVIO PARA ACTUALIZAR BD
            let codigo = 0
            if(argsCrud[0].ctrl_id === 'SI_ID'){
              codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
            }else{
              await this.crudBD(crudColecc[0], argsCrud[0], 0)
            }
            if(codigo!==0){
              for(let i=1; i<totDocCRUD; i++){
                argsCrud[i]._id = codigo
              }
            }
            // console.log("inicio")
            for(let i=1; i<totDocCRUD; i++){
              await this.crudBD(crudColecc[i], argsCrud[i], i)
            }
      console.log("final")
          }
          
  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showProc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProc: true})
  }

  showProcRdoTerc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcRdoTerc: true})
  }

  showProcCAR = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcCAR: true})
  }

  selCiudad = () => {
    if(this.props.allDirmayor.allDirmayor){
      const argsAdd = this.state.argsAdd

      let listaDir = this.props.allDirmayor.allDirmayor
      if(this.props.codigoDptoUA!=="Todos..."&&this.props.codigoCiudadUA==="Todas..."){
        listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
        argsAdd['codigoDpto'] = listaDir[0].codigoDpto
        argsAdd['descrDpto'] = listaDir[0].descrDpto
        argsAdd['_id'] = listaDir[0]._id
        this.setState({argsAdd});
      }
      if(this.props.codigoCiudadUA!=="Todas..."){
        const argsAdd = this.state.argsAdd
        let dptoOK = false
        listaDir.forEach((elemento, _id) => {
          if(!dptoOK){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                dptoOK = true
                argsAdd['codigoDpto'] = elemento.codigoDpto
                argsAdd['descrDpto'] = elemento.descrDpto
                argsAdd['_id'] = elemento._id
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                this.setState({argsAdd});
                // console.log(argsAdd)
              }
            })
          }
        })
        // console.log(argsAdd)
      }
      // console.log(lista1)
    }
  }

  showProcPagoTer = (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showProcPagoTer: true})

    this.selCiudad()
  }

  showProcDX = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcDX: true})

    this.selCiudad()
  }

  showProcCliDX = (ev) => {
    ev.preventDefault()
    this.props.allProcDX.refetch()
    this.estadosFalse()
    this.setState({showProcCliDX: true})

    this.selCiudad()
  }

  verCliDX = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({verCliDX: true})
  }

  showProcATOS = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcATOS: true})

    this.selCiudad()
  }

  showProcAT = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcAT: true})
    
    this.selCiudad()
  }

  showProcCS = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcCS: true})

    this.selCiudad()
  }
  
  showProcEC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcEC: true})

    this.selCiudad()
  }

  showProcAdm = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProcAdm: true})
  }

  showCambContr = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCambContr: true})

    this.selCiudad()
  }

  showCliNu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCliNu: true})

    this.selCiudad()
  }

  showCliUpd = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCliUpd: true})

    this.selCiudad()
  }

  showOSDX = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOSDX: true})

    this.selCiudad()
  }

  showOSSC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOSSC: true})

    this.selCiudad()
  }

  showTC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTC: true})

    this.selCiudad()
  }
  
  showArchNC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showArchNC: true})
  }
  
  showArchClNd = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showArchClNd: true})
  }
  
  handleClickArchCarAdic = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({handleClickArchCarAdic: true})
  }

  showArchAjNeg = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showArchAjNeg: true})
  }

  showArchAjPos = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showArchAjPos: true})
  }

  handleChange = (ev)=>{
    console.log(ev.target.value)
    // console.log(ev.target.checked)
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    this.setState({argsAdd});
  }

  handleChangeBuscProc = (ev)=>{
    const argsBuscCliente = this.state.argsBuscCliente
    argsBuscCliente[ev.target.name] = ev.target.value
    this.setState({argsBuscCliente});
  }

  handleBuscCliente = async (ev, args) => {
    ev.preventDefault()
    // console.log("Buscar")
    // console.log(args)
    let argsBuscar={}
    if(args.contrato){
      argsBuscar.contrato=args.contrato
    }else{
      argsBuscar.contrato=null
    }
    if(args.descrClaseServ){
      argsBuscar.descrClaseServ=args.descrClaseServ
    }else{
      argsBuscar.descrClaseServ=null
    }
    if(args.descripcionServicio){
      argsBuscar.descripcionServicio=args.descripcionServicio
    }else{
      argsBuscar.descripcionServicio=null
    }
    if(args.estadoDetDX){
      argsBuscar.estadoDetDX=args.estadoDetDX
    }else{
      argsBuscar.estadoDetDX=null
    }
    this.setState({argsBuscar})
  }

  handleRecPagoTer = async (ev, args, listServTarRC, totRecibido, clienteSel)=>{
    // console.log(args)
    // console.log("00", listServTarRC)
    // console.log(totRecibido)
    // console.log(clienteSel)
    let totDocCRUD = 100
    const errors = []
    let saldoPendiente = -99999999
    if(this.props.allClientes2.allClientes){
      let {data} = await this.props.allClientes2.refetch({contrato: args.contrato})
      saldoPendiente = await data.allClientes[0].saldoPendiente
    }    
    if(saldoPendiente === -99999999){
      errors.push({path: 'Pago', message: `Cargando la información del cliente`});
    }

    if(this.props.allPagoRtes.allPagoRtes&&args.numeroRT){
      // console.log(this.props.allPagoRtes.allPagoRtes, args.numeroRT)
      let buscarNumeroRT = {tipoqry: `[{$match: {numeroRT: "${args.numeroRT}"}}]`}  
      let {data} = await this.props.allPagoRtes.refetch(buscarNumeroRT)
      if(data.allPagoRtes.length>0){
        errors.push({path: '# Recibo', message: `El número de recibo ${args.numeroRT} ya fue utilizado (Contrato: ${data.allPagoRtes[0].contrato}, Fecha: ${data.allPagoRtes[0].fechaPago.substr(0, 10)})`});
      }
    }

//cuando tienen varias sesiones abiertas, en una hacen ajuste que cambia el saldo y en otra tenian
//cargada la pantalla de recibir pagos (el detalle esta antes del ajuste) => al hacer pago
//el detalle pend x pagar es diferente para solucionar =>
let pxp = 0
// listServTarRC.forEach((elemento, ii) => {
for(let ii=0; ii<listServTarRC.length; ii++){
  let elemento = listServTarRC[ii]
  pxp += elemento.valorTotal - elemento.valorPagado
}
// })
let listServTar = []
if(pxp!==saldoPendiente){
  // console.log(pxp, saldoPendiente)
  // errors.push({path: 'Valor pagado', message: `El saldo del cliente ha cambiado, por favor actualice la pantalla`});
  await this.props.allMovClientes2.refetch({contrato: args.contrato})
  listServTar = await this.props.allMovClientes2.allMovClientes
  listServTar = await listServTar.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
  let totRecib = totRecibido
  // listServTar.forEach((elemento, i) => {
  for(let i=0; i<listServTar.length; i++){
    let elemento = listServTar[i]
    if(elemento.valorTotal<0){
      totRecib -= elemento.valorTotal
      listServTar[i].valorRecibido = elemento.valorTotal
    }
  }
  // })
  // listServTar.forEach((elemento, i) => {
  for(let i=0; i<listServTar.length; i++){
    let elemento = listServTar[i]
    if(elemento.valorTotal>0){
      if(totRecib > elemento.valorTotal - elemento.valorPagado){
        totRecib -= (elemento.valorTotal - elemento.valorPagado)
        listServTar[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
      }else{
        listServTar[i].valorRecibido = totRecib
        totRecib = 0
      }
    }
  }
  // })
}else{
  listServTar = listServTarRC
}
//Fin controlar pxp
// console.log(listServTar)

// console.log(args.contrato, saldoPendiente)
    let totRecib = 0
    let argsUpd = {}
    // listServTar.forEach((elemento, i) => {
    for(let i=0; i<listServTar.length; i++){
      let elemento = listServTar[i]
      if(elemento.valorTotal<0&&elemento.valorTotal!==elemento.valorRecibido){
        errors.push({path: 'Valor pagado', message: `Para el concepto ${elemento.descripcionServicio} debe descontar todo el valor ($${elemento.valorTotal}) `});
      }else{
        if(elemento.valorRecibido){
          if(elemento.valorRecibido<0&&elemento.valorTotal>0){
            errors.push({path: 'Valor pagado', message: `El valor del pago ${elemento.valorRecibido} no puede ser menor que cero`});
          }else{
            if(elemento.valorRecibido>elemento.valorTotal - elemento.valorPagado){
              errors.push({path: 'Valor pagado', message: `El valor del pago ${elemento.valorRecibido} no puede ser mayor que el pendiente por pagar ${elemento.valorTotal - elemento.valorPagado}`});
            }else{
              totRecib += parseInt(elemento.valorRecibido, 10)
            }
          }
        }
      }
    }
    // })
// console.log(args)
    if(!args.numeroDocum){
      errors.push({path: 'Tercero', message: `Por favor seleccione el tercero`});
    }
    if(!args.descrOficina||args.descrOficina==="Todas..."||args.descrOficina==="Seleccionar..."){
      errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
    }  
    if(totRecibido<=0){
      errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} debe ser mayor que cero`});
    }
    // if(totRecibido>saldoPendiente){
    //   errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} es mayor al saldo pendiente ${saldoPendiente}`});
    // }
    if(totRecibido<=saldoPendiente&&totRecib!==totRecibido){
      errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} no coincide con el valor relacionado en el detalle por pagar ${totRecib}`});
    }
    if(totRecibido>saldoPendiente&&totRecib!==saldoPendiente&&saldoPendiente>0){
      errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} es mayor al valor relacionado en el detalle por pagar ${totRecib}, debe quedar pago todo el detalle relacionado como pendiente por pagar`});
    }

    let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
    let horaEntrada = new Date().getTime();
    let difHoraEntrada = 3000
    if(horaEntradaAnt){
      // console.log(horaEntradaAnt)
      difHoraEntrada = horaEntrada - horaEntradaAnt
    }else{
      difHoraEntrada = 8000
    }
    // if(difHoraEntrada>3000){
    //   console.log(difHoraEntrada)
    // }
    
    this.setState({errorAdd: errors})
    // console.log(errors)
    
    let aleatorio1 = sessionStorage.getItem('aleatorio1')
    let aleatorio2 = sessionStorage.getItem('aleatorio2')
    // console.log(errors.length, difHoraEntrada, aleatorio1, aleatorio2)
    if(errors.length===0&&difHoraEntrada>4000&&aleatorio1!==aleatorio2){  
    // if(errors.length===0&&difHoraEntrada>4000){
    // console.log(errors.length, difHoraEntrada, aleatorio1, aleatorio2)
      sessionStorage.setItem("horaEntrada", horaEntrada);
      sessionStorage.setItem("aleatorio2", aleatorio1);

      let mayorValPag = 0
      let listColecc = listServTar.map(recpago => ({...recpago}))

      let numeroRC = await this.nextVal('reccajas')
      numeroRC = numeroRC.toString()
  
      if(totRecibido>saldoPendiente){
//traer clase si todos los servicios de la tarifa son d la misma clase
        let claseServSig = "NoDefinida", claseServSig1 = ""
        if(clienteSel.tarifa.codigoTarifa){
          claseServSig1 = clienteSel.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
          claseServSig = clienteSel.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
          // clienteSel.tarifa.servicios.forEach((elemento, _id) => {
            for(let i=0; i<clienteSel.tarifa.servicios.length; i++){
              // let elemento = listServTar[i]
            if(claseServSig1!==claseServSig){
              claseServSig = "NoDefinida"
            }
          }
          // })
        }
// console.log(claseServSig)

        if(saldoPendiente>=0){
          mayorValPag = totRecibido - saldoPendiente
        }else{
          mayorValPag = totRecibido
        }        
        argsUpd = {
          // "idMovClientes": "0",
          "contrato": args.contrato,
          "codigoServicio": "MAYPAG",
          "nombreResumido": "Mayor valor pagado",
          "descripcionServicio": "Mayor valor pagado",
          "descrClaseServ": claseServSig,
          "concepto": "Mayor valor pagado",
          "periodo": "",
          "valorTotal": mayorValPag,
          "valorRecibido": mayorValPag,
          "numeroOdeDX": 0,
          "procesado": "S",
        }
        listColecc.push(argsUpd)
      }
  
      // let fechaHoy = new Date()
      // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 8)

      let argsAdd = args
      // let numeroRC = await this.nextVal('reccajas')
      // let numeroRC = 27002

      let creaColecc = [], movColecc = []
      let numDX = clienteSel.numeroOdeDX
      let saldoCl = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)

      let saldoClAjCero = saldoCl, hacerAjCero = false
      if(Math.abs(saldoCl)<=this.props.ajCero&&saldoCl!==0&&this.props.ajCero>0){
  //Ajuste a CERO por parametro ajCero
        saldoClAjCero = 0
        hacerAjCero = true
      }
// console.log(saldoClAjCero, hacerAjCero)
      // argsAdd['contrato'] = argsAdd.contrato
      argsAdd['saldoPendiente'] = saldoCl
      // argsAdd['fechaPago'] = fechaHoy
      argsAdd['fechaPago'] = argsAdd.fechaPago
      argsAdd['tipo'] = "PT"
      argsAdd['descripcionPago'] = "Pago en tercero"
      argsAdd['numeroRC'] = numeroRC
      argsAdd['documento'] = numeroRC
      // argsAdd['numeroRT'] = argsAdd.numeroRT
      // argsAdd['numeroDocum'] = argsAdd.numeroDocum
      // argsAdd['descrRecurso'] = argsAdd.descrRecurso
      argsAdd['valorTotal'] = totRecibido
      // argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
      argsAdd['fechaCreate'] = argsAdd.fechaPago + ' ' + horaHoy
      argsAdd['usuarioCreate'] = sessionStorage.getItem('userLogin')
      creaColecc.push(argsAdd)
// console.log(argsAdd)
      // listColecc.forEach((elemento1, ii) => {
      for(let ii=0; ii<listColecc.length; ii++){
        let elemento1 = listColecc[ii]
        if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
          argsUpd = {
            "contrato": argsAdd.contrato,
            "tipoAct": ii===0?"CreardetallePC1":"CreardetallePC2",
            "idMovClientes": elemento1._id,
            "codigoServicio": elemento1.codigoServicio,
            "nombreResumido": elemento1.nombreResumido,
            "descripcionServicio": elemento1.descripcionServicio,
            "descrClaseServ": elemento1.descrClaseServ,
            "concepto": elemento1.concepto,
            "periodo": elemento1.periodo,
            "valorTotal": elemento1.valorTotal,  
            "valorDetalle": elemento1.valorRecibido,
          }
          movColecc.push(argsUpd)
        }
      }
      // })

//CREA REGISTRO EN HISTCLIENTES
// console.log(args.numeroRT)
      let creaHC = []
      let argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": args.contrato,
        "movimiento": "Pago",
        "descripcion": `Tercero: ${args.descrRecurso}`,
        "detalle": "A saldo pendiente",
        "relacion": numeroRC,
        "numeroRT": args.numeroRT,
        "valor": totRecibido,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      creaHC.push(argsAddHC)

//Crear el pago y su detalle
      let numDocCRUD = 0
      totDocCRUD = movColecc.length + 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editPagoClientesUpdDoc)
      }

      argsCrud[numDocCRUD] = creaColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'

      crudColecc[numDocCRUD] = this.props.createPagoClientes

      numDocCRUD += 1

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })
// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

// //Crear el registro en histclientes
//       let creaHCMany = [], creaHCMany1 = []
//       creaHC.forEach((elementoHC, ii) => {
//         creaHCMany.push(elementoHC)
//       })
//       creaHCMany1.push({histcliente: creaHCMany})

//       numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
//       for(let iii=0; iii<totDocCRUD; iii++){
//         argsCrud.push({ctrlCampo: 'NO_CRUD'})
//       }
//       for(let iii=0; iii<totDocCRUD; iii++){
//         crudColecc.push(this.props.createHistClienteMany)
//       }

//       argsCrud[numDocCRUD] = creaHCMany1[0]
//       argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
//       argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
//       crudColecc[numDocCRUD] = this.props.createHistClienteMany

// // console.log(crudColecc)
// // console.log(argsCrud)
// // console.log(totDocCRUD)
//       this.updColecc(crudColecc, argsCrud, totDocCRUD)

//actualizar saldo en clientes
//crear mov de pago en movclientes
//actualizar valor pagado en movclientes
let estCl = clienteSel.estadoCliente
let ultFRX = clienteSel.fecgaUltRX

let actColecc = [], movCli = [], movCliRX = [], actServCli = []
creaColecc = []
movColecc = []
//se pasa despues de verificar si se crean movcliente de RX por DX masiva porque afecta el saldo y estado
      // argsUpd = {
      //   "tipoAct": "EditarCliOdeS",
      //   "_id": clienteSel._id,
      //   "estadoCliente": clienteSel.estadoCliente,
      //   "cargoMensual": clienteSel.cargoMensual,
      //   "saldoPendiente": saldoCl,
      // }
      // actColecc.push(argsUpd)

      argsAdd = {
        "contrato": argsAdd.contrato,
        "fechaMov": fechaHoy,
        "tipo": "D",
        "subTipo": "PO",
        "procesado": "S",
        "origen": "Pago en tercero",
        "codigoServicio": argsAdd.numeroDocum,
        "nombreResumido": argsAdd.descrRecurso,
        "descripcionServicio": argsAdd.descrRecurso,
        "descrClaseServ": argsAdd.descrRecurso,
        "concepto": argsAdd.descrRecurso,
        "saldoCliente": saldoCl,
        "valorTotal": totRecibido,
        "valorAntesImptos": totRecibido,
        "numeroRC": numeroRC,
        "documento": numeroRC,
        "valorPagado": totRecibido,
        "fechaUltPago": fechaHoy,
        "valorUltPago": totRecibido,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
        "fechaCreate": fechaHoraHoy,
      };
      // creaColecc.push(argsAdd)
      movCli.push(argsAdd)

      let valorparaPermRX = this.props.empresa.valorparaPermRX
      let hacerRX = true
      if(numDX===0){
        hacerRX = false
      }

// console.log("11", listServTar)
// console.log("22", listColecc)
      for(let ii=0; ii<listServTar.length; ii++){
        let elemento1 = listServTar[ii]
        if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
            elemento1.valorTotal>0&&!hacerAjCero){
          hacerRX = false
        }
        if((elemento1.valorRecibido&&elemento1.valorRecibido!==0) || hacerAjCero){
          let valPagado = 0
          if(elemento1.valorPagado){
            valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
          }else{
            valPagado = parseInt(elemento1.valorRecibido, 10)
          }
          let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
          // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0){
          if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0){
            // console.log("33")
              hacerRX = false
          }

          let valorPagadoDet = valPagado, valorPendienteDet = elemento1.valorTotal - valPagado
          if(hacerAjCero){
            //Ajuste a CERO por parametro ajCero
            valorPagadoDet = elemento1.valorTotal
            valorPendienteDet = 0
          }
  
          argsUpd = {
            "contrato": argsAdd.contrato,
            "_id": elemento1._id,
            "procesado": elemento1.procesado,
            "concepto": elemento1.concepto,
            "numeroFra": elemento1.numeroFra,
            "numeroRC": elemento1.numeroRC,
            "numeroCE": elemento1.numeroCE,
            "numeroOdeDX": elemento1.numeroOdeDX,
            "documento": elemento1.documento,
            "fechaUltPago": fechaHoy,
            "valorUltPago": elemento1.valorRecibido,
            "valorPagado": valorPagadoDet,
            "valorPendiente": valorPendienteDet
          }
          // console.log(argsUpd)
          movColecc.push(argsUpd)
        }
      }
      // })
      // console.log(movColecc)
      if(hacerRX){
//         console.log(this.props.comoAsigCargosAlCliente)
// console.log(saldoCl)
let saldoClCC = saldoCl

// let fechaHoy = new Date()
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
let response = await this.props.fecha({
  variables: {}
});
const {fechaHoraHoy} = response.data.fecha
let fechaHoy = fechaHoraHoy.substr(0, 10)

//traer el número de días del mes
const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1

let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
let periodoFrado = ""
// let numServ=0

let elemento3 = []
let difSaldoNeg = 0, valorPagNeg = 0
//verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
//los cargos positivos
if(clienteSel.tarifa.codigoTarifa){
  elemento3 = clienteSel.tarifa
  // elemento3.servicios.forEach((elemento1, i) => {
  for(let i=0; i<elemento3.servicios.length; i++){
    let elemento1 = elemento3.servicios[i]
    if(elemento1.estadoServicio==="D"){
      let numDNvo = numDM - ddI
      let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
      
      if(valorServ<0){
        valorPagNeg += valorServ
      }
    }
  }
  // })
  if(saldoCl<(valorPagNeg * -1)){
    difSaldoNeg = (valorPagNeg * -1) - saldoCl
  }
}
        //PROCESO CREAR DOCUM DE CARGUE EN MOVIMCLIENTE POR DX
        // console.log("44")
        
              // console.log("Hacer RX")
              let agnoFra = fechaHoy.substr(0, 4)
              let mesFra = fechaHoy.substr(5, 2)
        
        //traer el número de días del mes
              elemento3 = []
        
              // listServTar.forEach((elemento, ii) => {
              //   if(numDX>0&&elemento.numeroOdeDX>0){
                  if(clienteSel.tarifa.codigoTarifa){
                    elemento3 = clienteSel.tarifa
        // console.log(elemento3)
                    // elemento3.servicios.forEach((elemento1, i) => {
                    for(let i=0; i<elemento3.servicios.length; i++){
                      let elemento1 = elemento3.servicios[i]
                    
                      // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
                      if(elemento1.estadoServicio==="D"){
        //Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
                        // let listServCargoFra = []
                        let numDNvo = numDM - ddI
                        let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
                        let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)
        
                        let valorPag = 0
                        if(difSaldoNeg>0&&valorServ>0){
                          if(difSaldoNeg-valorServ>=0){
                            valorPag = valorServ
                          }else{
                            valorPag = difSaldoNeg
                          }
                          difSaldoNeg -= valorPag
                        }
                
                        if(saldoCl<0&&valorServ>0){
                          if(saldoCl+valorServ>0){
                            valorPag = saldoCl * -1
                          }else{
                            valorPag = valorServ
                          }
                        }
                        if(valorServ<0){
                          valorPag = valorServ
                        }                
        
                        periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
                        periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM

                        periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
                        periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM
        
                        let numServ = elemento1.numeroServicios
        
                        if(numServ!==0){
                          let imptosServ = elemento1.imptos.map(impto => ({
                            ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
                
                          if(valorServ!==0){
                            // listServCargoFra.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                            //   codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                            //   _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                            //   descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                            //   codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                            //   numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
                            //   agnoFra: agnoFra, mesFra: mesFra, fechaCargo: fechaHoy, periodoFrado: periodoFrado,
                            //   valorAntesImptos: valorAntesI,
                            //   _id: i
                            // });
        
        //CREA REGISTRO EN movclientes
                            saldoCl += valorServ

                            // argsUpd = {}
                            // console.log("55")
        
                            let movCliI = [], actCargoFra = []
                            let argsUpdI = {}
                            imptosServ.forEach((elementoI, ii) => {
                              if(elementoI.codigoImpto!==null){
                                argsUpdI = {
                                  "codigoImpto": elementoI.codigoImpto,
                                  "descrImpto": elementoI.descrImpto,
                                  "porcImpto": elementoI.porcImpto,
                                  "valorImpto": elementoI.valorImpto,
                                }
                                movCliI.push(argsUpdI)
                              }
                            })

//PARA CUANDO SE FACTURA UN MES ANTERIOR
                    let ultMF = ""
                    let tieneMCCMesAnt = true
                    let lista8CC = this.props.list4CC
// console.log(lista8CC)
// console.log(this.props.list4CC)
                    let agno = fechaHoy.substr(0, 4)
                    let mes = fechaHoy.substr(5, 2)

                    let ultPF = this.props.list5.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
                    if(ultPF.length>0){
                      ultMF = ultPF[ultPF.length-1].mes
                    }
                    let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
// console.log(difmesesUMF)
// console.log(clienteSel.cicloFact)
//Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
//en movcliccs
                    if(difmesesUMF>1){
                      let mesMA = parseInt(mes, 10)
                      let agnoMA = agno
                      if(mes==="01"){
                        agnoMA = (parseInt(agno, 10) - 1).toString()
                        mesMA = "12"
                      }else{
                        mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                      }
// console.log(agnoMA + "-" + mesMA)
                      let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
// console.log(indexFrado)                      
                      if(indexFrado===-1){
//NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
//como NO FACTURAR
                        tieneMCCMesAnt = false
                      }  
                    }

            //verificar si NO tiene mov en el mes ant
                    if(!tieneMCCMesAnt){
              //verificar si esta des, sus o ret, la os lo va a pasar a act
                      if(clienteSel.estadoCliente==="DESCONECTADO"||clienteSel.estadoCliente==="SUSPENDIDO"||
                        clienteSel.estadoCliente==="RETIRADO"){
              //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
              //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                        let fechaHoyMA = new Date()
                        let agnoMA = (fechaHoyMA.getFullYear()).toString()
                        let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                        mesMA = parseInt(mesMA, 10)
                        if(mesMA==="01"){
                          agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                          mesMA = "12"
                        }else{
                          mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                        }
                  // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                        let periodoFradoMA = "NO FACTURAR"
                  // let pruebaFMA =[]
                  // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,

                        argsUpd = {}
                        argsUpd = {
                          "contrato": args.contrato,
                          "fechaMov": fechaHoy,
                          "tipo": "C",
                          "subTipo": "RX",
                          "procesado": "N",
                          "codigoServicio": elemento1.codigoServicio,
                          "nombreResumido": elemento1.nombreResumido,
                          "descripcionServicio": elemento1.descripcionServicio,
                          "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                          "periodo": periodoFradoMA,
                          "origen": "DX-" + clienteSel.numeroOdeDX,
                          "saldoCliente": saldoCl,
                          "valorTotal": 0,
                          "valorAntesImptos": 0,
                          "agno": agnoMA,
                          "mes": mesMA,
                          "valorPagado": 0,
                          // "valorPendiente": elemento1.valorTotal - valorPag,
                          "usuarioCreate": sessionStorage.getItem('userLogin'),
                          "fechaCreate": fechaHoraHoy,
                          "imptos": []
                        };
                        actCargoFra.push(argsUpd)

                        // console.log(pruebaFMA)
                        // console.log(listServCargoFra)
                      }
                    }
//FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

                            argsUpd = {}
                            argsUpd = {
                              "contrato": args.contrato,
                              "fechaMov": fechaHoy,
                              "tipo": "C",
                              "subTipo": "RX",
                              "procesado": "N",
                              "codigoServicio": elemento1.codigoServicio,
                              "nombreResumido": elemento1.nombreResumido,
                              "descripcionServicio": elemento1.descripcionServicio,
                              "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                              "periodo": periodoFrado,
                              "origen": "DX-" + clienteSel.numeroOdeDX,
                              "saldoCliente": saldoCl,
                              "valorTotal": valorServ,
                              "valorAntesImptos": valorAntesI,
                              "agno": agnoFra,
                              "mes": mesFra,
                              "valorPagado": valorPag,
                              // "valorPendiente": elemento1.valorTotal - valorPag,
                              "usuarioCreate": sessionStorage.getItem('userLogin'),
                              "fechaCreate": fechaHoraHoy,
                              "imptos": movCliI
                            };
                            // console.log(argsUpd)
                            actCargoFra.push(argsUpd)
        // console.log(actCargoFra)
        // console.log("66")
        
        //Verificar si el servicio tiene oferta
                            if(clienteSel.oferta.codigoOferta){
                              let elemento3Of = clienteSel.oferta
        
                              // elemento3Of.servicios.forEach((elementoOf, i) => {
                              for(let i=0; i<elemento3Of.servicios.length; i++){
                                let elementoOf = elemento3Of.servicios[i]
        // console.log(elementoOf)
                                if(elementoOf.codigoServicio === elemento1.codigoServicio){
                                  let fechaInicial, fechaFinal
                                  !elementoOf.fechaInicioOferta?fechaInicial = fechaHoy:fechaInicial = elementoOf.fechaInicioOferta
                                  if(!elementoOf.fechaFinOferta){
                                    fechaFinal = new Date(elementoOf.fechaInicioOferta?elementoOf.fechaInicioOferta:fechaHoy)
                                    fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elementoOf.numDiasOferta, 10))
                                    fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
                                  }else{
                                    fechaFinal = elementoOf.fechaFinOferta
                                  }
        
                                  let fechaInicio = new Date(fechaInicial).getTime();
                                  let fechaFin    = new Date(fechaFinal).getTime();
                                  let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
                                  if(numdiApliOf>numDF){
                                    numdiApliOf = numDF
                                  }
        
                                  // listServOfAct.push({codigoOferta: elemento3Of.codigoOferta, descrOferta: elemento3Of.descrOferta,
                                  //   codigoServicio: elementoOf.codigoServicio, nombreResumido: elementoOf.nombreResumido, descripcionServicio: elementoOf.descripcionServicio,
                                  //   _idSubclaseServ: elementoOf.subclaseserv._id, codigoSubclaseServ: elementoOf.subclaseserv.codigoSubclaseServ,
                                  //   descrSubclaseServ: elementoOf.subclaseserv.descrSubclaseServ, _idClaseServ: elementoOf.subclaseserv.claseserv._id,
                                  //   codigoClaseServ: elementoOf.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elementoOf.subclaseserv.claseserv.descrClaseServ,
                                  //   porcDctoOferta: elementoOf.porcDctoOferta, numDiasOferta: elementoOf.numDiasOferta,
                                  //   numdiApliOf: numdiApliOf, _id: i
                                  // });
        
        // console.log(elemento.codigoServicio)
                                  let valorDcto = 0
                                  let valorDctoAI = 0
                                  if(numDF===numdiApliOf){
                                    // console.log("of11")
                                    valorDcto = actCargoFra[0].valorTotal - (actCargoFra[0].valorTotal * elementoOf.porcDctoOferta / 100)
                                    valorDctoAI = actCargoFra[0].valorAntesImptos - (actCargoFra[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)
                                  }else{
                                    // console.log("of22")
                                    valorDcto = (actCargoFra[0].valorTotal - (actCargoFra[0].valorTotal * elementoOf.porcDctoOferta / 100)) / numDF
                                    valorDcto = valorDcto * numdiApliOf
                                    valorDctoAI = (actCargoFra[0].valorAntesImptos - (actCargoFra[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)) / numDF
                                    valorDctoAI = valorDctoAI * numdiApliOf
                                  }
                                  // const indexLis = actCargoFra.findIndex(codServ => codServ.codigoServicio === elemento2.codigoServicio);
                                  valorDcto = parseInt(valorDcto, 10)
                                  valorDctoAI = parseInt(valorDctoAI, 10)
                                  // console.log(valorDcto)
                                  if(valorDcto!==0){
                                    saldoCl += valorDcto - valorServ
                                    actCargoFra[0].valorTotal = valorDcto
                                    actCargoFra[0].valorAntesImptos = valorDctoAI
                                    actCargoFra[0].saldoCliente = saldoCl
        
        //Actualizar imptos con la oferta
                                    actCargoFra[0].imptos.forEach((elemento2, i) => {
                                      elemento2.valorImpto = Math.round(valorDctoAI * elemento2.porcImpto / 100)
                                    })
                                  }else{
                                    // if(indexLis!==-1){
        //pongo comentario porque no veo para que se elimina del array => ????
        // actCargoFra.splice(indexLis, 1);
                                    // }
                                  }
                                }
                              }
                              // })
                            }
// console.log(actCargoFra)
                            // actCargoFra.forEach((elementoDX, ii) => {
                            for(let ii=0; ii<actCargoFra.length; ii++){
                              let elementoDX = actCargoFra[ii]

                              if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                                movCliRX.push(elementoDX)
                              }else{
                                movCli.push(elementoDX)
                              }
                              // console.log("77")
        
                              argsUpd = {}
                              argsUpd['tipoAct'] = "EditarServDX"
                              argsUpd['contrato'] = args.contrato
                              argsUpd['tarifa'] = { codigoTarifa: clienteSel.tarifa.codigoTarifa, servicios: 
                                                [{"codigoServicio": elementoDX.codigoServicio,
                                                  "estadoServicio": "A"}]}
                              actServCli.push(argsUpd)
                            }
                            // })
                          }
                        }
                      }
                    }
                    // })
                  }
              //   }
              // })
        // //FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
        if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
          saldoCl = saldoClCC
        }
  // console.log(saldoCl)
        argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": args.contrato,
          "movimiento": "Pago",
          "descripcion": `Tercero: ${args.descrRecurso}`,
          "detalle": "Se hace RX por pago",
          "relacion": numeroRC,
          "valor": totRecibido,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        creaHC.push(argsAddHC)
      }
      // console.log("88")
//Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      // console.log(movCli)
      if(movCli.length>0){
        let actCli = [], actCliMany = [], movCliMany = [], movCliRXMany = [], actServCliMany = []
  
        let numOdeDX = 0
        if(!hacerRX&&clienteSel.numeroOdeDX>0){
          numOdeDX = clienteSel.numeroOdeDX
        }
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliDX",
          "contrato": args.contrato,
          "numeroOdeDX": numOdeDX,
        }
        actCli.push(argsUpd)
        actCli.forEach((elementoDX, ii) => {
          actCliMany.push(elementoDX)
        })
        movCli.forEach((elementoDX, ii) => {
          movCliMany.push(elementoDX)
        })
        movCliRX.forEach((elementoDX, ii) => {
          movCliRXMany.push(elementoDX)
        })
        actServCli.forEach((elementoDX, ii) => {
          actServCliMany.push(elementoDX)
        })
  
        let actCliMany1 = [], movCliRXMany1 = []
        actCliMany1.push({cliente: actCliMany})
        let movCliMany1 = []
        movCliMany1.push({movcliente: movCliMany})
        if(movCliRX.length>0){
          movCliRXMany1.push({movcliente: movCliRXMany})
        }
        let actServCliMany1 = []
        actServCliMany1.push({cliente: actServCliMany})
  
        numDocCRUD = 0
        if(movCliRX.length>0){
          totDocCRUD = 4
        }else{
          totDocCRUD = 3
        }
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.createMovClientesMany)
        }
  
        argsCrud[numDocCRUD] = actCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteMany
  
        numDocCRUD += 1
  
        argsCrud[numDocCRUD] = actServCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

        numDocCRUD += 1

        if(movCliRX.length>0){
          argsCrud[numDocCRUD] = movCliRXMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.createMovCliCCMany
  
          numDocCRUD += 1
        }

        argsCrud[numDocCRUD] = movCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createMovClientesMany
  
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        this.updColecc(crudColecc, argsCrud, totDocCRUD)
  
        if(clienteSel.estadoCliente!=="ACTIVO"&&hacerRX){
          estCl = "ACTIVO"
          ultFRX = fechaHoy
        }
      }

      //ACTUALIZAR DIASMORA
      //para calcular diasmora =>
      //diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
      // let movimDX1 = await listServTar.map(movim => ({
      //   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
      let actCli = [], fechaPH = null
      if(saldoCl>0){
        let fechaMora = new Date()
        fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
        let movimDX1 = await listServTar.map(movim => ({
          ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
        let fechaHoy1 = new Date()
        let diasHoy = fechaHoy1.getUTCDate()
        let mesHoy = fechaHoy1.getMonth()+1

        let diasMora = 0, diasMoraMayor = 0
        // await movimDX1.forEach((movim, ii) => {
        for(let ii=0; ii<movimDX1.length; ii++){
          let movim = movimDX1[ii]

          diasMora = 0
          if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
            if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&clienteSel.cargoMensual>0){
      //Math.ceil redondea al entero por encima
      // console.log(movim)
                let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / clienteSel.cargoMensual)
                if(movim.codigoServicio==="SISTV"){
                  diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
                }else{
                  diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
                }
      // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
            }else{
              diasMora = movim.diasMora
            }
          }
          if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
            diasMoraMayor = diasMora
          }
        }
        // })
        if(diasMoraMayor!==0){
          let fechaInicio = new Date(fechaMora).getTime();
          let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
          fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
        }else{
          fechaPH = null
        }
        // console.log(argsUpd)
      }else{
        fechaPH = null
      }
      argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarCliPagueHasta",
        "contrato": clienteSel.contrato,
        "pagueHasta": fechaPH,
      }
      actCli.push(argsUpd)
      //FIN ACTUALIZAR DIASMORA

      argsUpd = {
        "tipoAct": "EditarCliOdeS",
        "_id": clienteSel._id,
        "estadoCliente": estCl,
        "cargoMensual": clienteSel.cargoMensual,
        "saldoPendiente": saldoClAjCero,
      }
      actColecc.push(argsUpd)

      let actFechas = []
      argsUpd = {
        "tipoAct": "EditarFechCli",
        "_id": clienteSel._id,
        "fechaUltOSAb": clienteSel.fechaUltOSAb,
        "fechaPrimeraActivacion": clienteSel.fechaPrimeraActivacion,
        "fechaUltDX": clienteSel.fechaUltDX,
        "fecgaUltRX": ultFRX,
        "estadoAnterior": clienteSel.estadoAnterior,
        "fechaUltOSCe": clienteSel.fechaUltOSCe,
        // "fechaUltPago": fechaHoy,
        "fechaUltPago": args.fechaPago,
        "valorUltPago": totRecibido,
      }
      actFechas.push(argsUpd)

      numDocCRUD = 0
      totDocCRUD = movColecc.length + 3
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientes)
      }

      argsCrud[numDocCRUD] = actFechas[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente
  
      numDocCRUD += 1

      argsCrud[numDocCRUD] = actCli[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente
  
      numDocCRUD += 1

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })
      
      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente

      // numDocCRUD += 1
      
      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)


      if(hacerAjCero){
//HACER AJUSTE A SALDO CERO
        let numeroAjuste = await this.nextVal('aju')
        numeroAjuste = numeroAjuste.toString()
        let tipoAjuste = "", clase = "", origen = ""
    
        if(saldoCl<0){
          tipoAjuste = "AP"
          origen = `Ajuste positivo ${numeroAjuste}`
          clase = "Ajuste positivo"
        }else{
          tipoAjuste = "AN"
          origen = `Ajuste negativo ${numeroAjuste}`
          clase = "Ajuste negativo"
        }
    
        let argsAddAj = {}
        creaColecc = []
        argsAddAj['tipoAjuste'] = tipoAjuste
        argsAddAj['numeroAjuste'] = numeroAjuste
        argsAddAj['fechaAjuste'] = fechaHoy
        argsAddAj['contrato'] = args.contrato
        argsAddAj['concepto'] = "Ajuste a saldo cero"
        argsAddAj['valorAjuste'] = saldoCl
        creaColecc.push(argsAddAj)
    
        creaHC = []
        argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": args.contrato,
          "movimiento": "Ajuste",
          "descripcion": clase,
          "detalle": "Ajuste a saldo cero",
          "relacion": numeroAjuste,
          "valor": saldoCl,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        creaHC.push(argsAddHC)
    
        let claseServSig = "NoDefinida", claseServSig1 = ""
        if(clienteSel.tarifa.codigoTarifa){
          claseServSig1 = clienteSel.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
          claseServSig = clienteSel.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
          clienteSel.tarifa.servicios.forEach((elemento, _id) => {
            if(claseServSig1!==claseServSig){
              claseServSig = "NoDefinida"
            }
          })
        }
        // console.log(claseServSig)
        
        let creaColeccMC = []
        let valorMC = saldoCl * -1
        let argsAddMC = {
          "contrato": args.contrato,
          "fechaMov": fechaHoy,
          "tipo": "C",
          "subTipo": tipoAjuste,
          "procesado": "S",
          "nombreResumido": "Ajuste a saldo cero",
          "descripcionServicio": "Ajuste",
          "descrClaseServ": claseServSig,
          "concepto": "Ajuste",
          "origen": origen,
          "saldoCliente": 0,
          "valorTotal": valorMC,
          "valorAntesImptos": valorMC,
          "documento": numeroAjuste,
          "valorPagado": valorMC,
          "valorPendiente": 0,
          "numeroOdeDX": 0,
          "fechaCreate": fechaHoraHoy,
        };
        creaColeccMC.push(argsAddMC)
    
    //Crear el ajuste, histclientes y movclientes
        creaHCMany = []
        creaHCMany1 = []
        creaHC.forEach((elementoHC, ii) => {
          creaHCMany.push(elementoHC)
        })
        creaHCMany1.push({histcliente: creaHCMany})
    
        numDocCRUD = 0
        totDocCRUD = 3
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
    
        argsCrud[numDocCRUD] = creaColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createAjuste
    
        numDocCRUD += 1
    
        argsCrud[numDocCRUD] = creaHCMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createHistClienteMany
    
        numDocCRUD += 1
    
        argsCrud[numDocCRUD] = creaColeccMC[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createMovClientes
    
// console.log(argsCrud)
        this.updColecc(crudColecc, argsCrud, totDocCRUD)
//FIN HACER AJUSTE A SALDO CERO
      }


      if(args.numeroRT){
        var numeroRT = document.getElementById("numeroRT");
        let longNumero = args.numeroRT.length
        let nuevoNumero = args.numeroRT
        if(!isNaN(args.numeroRT)){
          nuevoNumero = "000000000000000" + (parseInt(args.numeroRT, 10) + 1).toString()
          nuevoNumero = nuevoNumero.substr(nuevoNumero.length - longNumero, longNumero)
        }else{
          for(let i=1; i<=longNumero; i++){
            let numero = args.numeroRT.substr(longNumero-i, 1)
            numero = parseInt(numero, 10)
            if(isNaN(numero)){
              numero = args.numeroRT.substr(longNumero-i+1, i-1)
              let longNum = numero.length
              if(!isNaN(numero)){
                nuevoNumero = "000000000000000" + (parseInt(numero, 10) + 1).toString()
                nuevoNumero = nuevoNumero.substr(nuevoNumero.length - longNum, longNum)
                nuevoNumero = args.numeroRT.substr(0, longNumero-i+1) + nuevoNumero
              }
              i = longNumero + 1
            }
          }
        }
        numeroRT.value = nuevoNumero
        // console.log(nuevoNumero)
      }
  
      let contrato = document.getElementById("contrato");
      contrato.value = ""
      contrato.focus()

//Si se deja algun setState sale error porque hay procesos asincronos
//   this.estadosFalse()
//   this.setState({showRecPago: true})
    }else{
      if(difHoraEntrada>3000){
        console.log("no entra")
        var valorEf = document.getElementById("valorEf");
        valorEf.value = 0
        var valorCh = document.getElementById("valorCh");
        valorCh.value = 0
        var valorTr = document.getElementById("valorTr");
        valorTr.value = 0
        var valorTC = document.getElementById("valorTC");
        valorTC.value = 0
        var valorTD = document.getElementById("valorTD");
        valorTD.value = 0
        var numeroCh = document.getElementById("numeroCh");
        numeroCh.value = ""
        var bancoCh = document.getElementById("bancoCh");
        bancoCh.value = ""        
        var fechaVencCh = document.getElementById("fechaVencCh");
        fechaVencCh.value = ""
        var bancoTr = document.getElementById("bancoTr");
        bancoTr.value = ""
        var fechaTr = document.getElementById("fechaTr");
        fechaTr.value = ""
        var bancoTD = document.getElementById("bancoTD");
        bancoTD.value = ""
        var bancoTC = document.getElementById("bancoTC");
        bancoTC.value = ""       
        
        let contrato = document.getElementById("contrato");
        contrato.focus()
      }
    }
  }

  handleCiudadDpto = () => {
    this.setState({argsAdd: {}})
    let miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    let miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleBarrioZona = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleBarrioSel = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4].value
    argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5].value

//     argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
//     argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
// //si miLista.options[miLista.selectedIndex].attributes[0] no existe pone codigoBarrio que es el value
// //=> se valida por miLista.options[miLista.selectedIndex].attributes[1]
//     argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[0].value:null
//     argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:null
//     argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
//     argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
//     argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
//     argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null
// console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleClaseSub = () => {
    var miLista4 = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrClaseServ'] = miLista4.options[miLista4.selectedIndex].text
    argsAdd['_idClaseserv'] = miLista4.options[miLista4.selectedIndex].value
    argsAdd['codigoClaseServ'] = miLista4.options[miLista4.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showRFact) {
      this.setState({verRFact: true})
    }
    if (this.state.showProcCliDX) {
      this.setState({verCliDX: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false, permiteClose: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true, permiteClose: false})
  }

  handleClickClo = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: false, permiteClose: true})
  }

  render(){
    const {showProc, showProcPagoTer, showProcRdoTerc, showProcCAR, showProcDX, showProcCliDX,
          showProcATOS, showProcAT, showProcCS, showProcEC, showProcAdm, showCambContr, showCliNu, showCliUpd,
          showOSDX, showOSSC, showTC, showArchNC, handleClickArchCarAdic, showArchAjNeg, showArchAjPos, showArchClNd,
          verCliDX, permiteUpdate, permiteDelete, permiteClose,
          argsAdd, errorAdd, argsBuscCliente, idLista, argsBuscar} = this.state;

      let lista = []
      let lista1 = []
      let lista2 = []
      let lista3 = []
      let lista7 = []

      if (this.state.showProcDX||this.state.showProcAT||this.state.showProcCS||
          this.state.showProcEC||this.state.showProcATOS) {
        if(this.props.allDirmayor.allDirmayor){
          lista1 = this.props.allDirmayor.allDirmayor
          if(this.props.codigoCiudadUA!=="Todas..."){
            let listaD = []
            lista1.forEach((elemento, _id) => {
              if(listaD.length===0){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    listaD.push(elemento)
                  }
                })
              }
            })
            lista1 = listaD
          }
          // console.log(lista1)
        }
      }
      if (this.state.showProcEC){
        if(this.props.allClasesServ.allClasesServ){lista3 = this.props.allClasesServ.allClasesServ}
        lista2.push({estadoCli: "NUEVO"})
        lista2.push({estadoCli: "ACTIVO"})
        lista2.push({estadoCli: "DESCONECTADO"})
        lista2.push({estadoCli: "SUSPENDIDO"})
        lista2.push({estadoCli: "RETIRADO"})
        lista7.push({datosConfirmados: "SI"})
        lista7.push({datosConfirmados: "NO"})
      }

      if (this.state.showProcDX) {
        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
        if(this.props.allRangoFact.allRangoFact&&!this.state.showProcCE){
          lista = this.props.allRangoFact.allRangoFact
          lista = lista.filter(elemento => elemento.estadoRangoFact===true)
        }
      }
      if (this.state.showProcPagoTer||this.state.showProcCAR) {
        if(this.props.allRecurso.allRecurso){
          lista7 = this.props.allRecurso.allRecurso
          if(this.props.numeroDocumUA==="Todos..."){
            lista7 = lista7.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
          }else{
            lista7 = lista7.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO'&&
                                  elemento.numeroDocum===this.props.numeroDocumUA)
          }
          if(this.props.codigoDptoUA!=="Todos..."){
            lista7 = lista7.filter(elemento => elemento.codigoDpto==="Todos..." || elemento.codigoDpto===this.props.codigoDptoUA)
          }
          if(this.props.codigoCiudadUA!=="Todas..."){
            lista7 = lista7.filter(elemento => elemento.codigoCiudad==="Todas..." || elemento.codigoCiudad===this.props.codigoCiudadUA)
          }
        }
      }
      // console.log(this.props.listaCF)
      // if (this.state.showProcRdoTerc) {
      //   if(this.props.allRdoTerc.allRdoTerc){
      //     lista = this.props.allRdoTerc.allRdoTerc
      //   }
      // }
      if (this.state.showProcCliDX) {
        if(this.props.allProcDX.allProcDX){
          lista = this.props.allProcDX.allProcDX
          if(this.props.codigoCiudadUA!=="Todas..."){
            lista = lista.filter(elemento => elemento.descrDpto===this.state.argsAdd.descrDpto&&
                                  elemento.nombreCiudad===this.state.argsAdd.nombreCiudad)
            // console.log(lista)
          }else{
            // console.log(lista)
          }
        }
      }

      return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showProc && <HomeProc1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                        handleClickSel1={this.showProcPagoTer} handleClickSel7={this.showProcRdoTerc}
                        handleClickSelCAR={this.showProcCAR}
                        handleClickSel2={this.showProcDX} handleClickSel3={this.showProcCliDX}
                        handleClickSelATOS={this.showProcATOS}
                        handleClickSel4={this.showProcAT} handleClickSel5={this.showProcCS}
                        handleClickSelEC={this.showProcEC}
                        handleClickSel6={this.showProcAdm}/>}

            {showProcPagoTer && <ProcPagoTer1 styles={this.props.styles} handleClickRegrRecPago={this.showProc}/>}
            {showProcRdoTerc && <ProcRdoTerc1 styles={this.props.styles} handleClickRegr={this.showProc}/>}
            {showProcCAR && <ProcCAR1 styles={this.props.styles} handleClickRegr={this.showProc}/>}

            {showProcDX && <ProcDX1 styles={this.props.styles} handleClickRegr={this.showProc}/>}
          
            {showProcCliDX && <ProcCliDX1 styles={this.props.styles} handleClickRegr={this.showProc}/>}
            {verCliDX && <VerCliDX1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showProcCliDX}
                        handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}
                        handleClickClo={this.handleClickClo} idLista={idLista}
                        args={argsBuscCliente} handleSubmit={this.handleBuscCliente}
                        handleChange={this.handleChangeBuscProc}/>}

            {showProcATOS && <ProcATOS1 styles={this.props.styles} handleClickRegr={this.showProc}/>}

            {showProcAT && <ProcAT1 styles={this.props.styles} handleClickRegr={this.showProc}/>}
            {showProcCS && <ProcCS1 styles={this.props.styles} handleClickRegr={this.showProc}/>}
            {showProcEC && <ProcEC1 styles={this.props.styles} handleClickRegr={this.showProc}/>}

            {(showProcAdm||showArchNC||handleClickArchCarAdic||showArchAjNeg||showArchAjPos||showArchClNd || showCambContr || showCliNu || showCliUpd || showOSDX || showOSSC || showTC) &&
                <ProcAdm1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                            handleClickRegr={this.showProc} handleClickArchCarAdic={this.handleClickArchCarAdic}
                            handleClickSel1={this.showCambContr}
                            handleClickSCliNu={this.showCliNu} handleClickSCliUpd={this.showCliUpd}
                            handleClickOSDX={this.showOSDX} handleClickOSSinCamb={this.showOSSC}
                            handleClickTCUpd={this.showTC}
                            handleClickSel2={this.showArchAjNeg} handleClickAjPos={this.showArchAjPos}
                            handleClickSel3={this.showArchNC}
                            handleClickSelClNd={this.showArchClNd}/>}

          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showProc && <HomeProc2 styles={this.props.styles}/>}

            {showProcPagoTer && <ProcPagoTer2 codigoCiudadUA={this.props.codigoCiudadUA}
                              codigoDptoUA={this.props.codigoDptoUA}
                              numeroDocumUA={this.props.numeroDocumUA} styles={this.props.styles}
                              list7={lista7} descrOficina={this.props.descrOficina}
                              empresa={this.props.empresa} 
                              listaOf={this.props.listaOf} handleSubmit={this.handleRecPagoTer}
                              handleChange={this.handleChange} args={argsAdd} errors={errorAdd}/>}
            {showProcRdoTerc && <ProcRdoTerc2 styles={this.props.styles} ajCero={this.props.ajCero}
                              descrOficina={this.props.descrOficina} listaOf={this.props.listaOf}
                              empresa={this.props.empresa} args={argsAdd} errors={errorAdd}/>}
            {showProcCAR && <ProcCAR2 styles={this.props.styles} list7={lista7} ajCero={this.props.ajCero}
                              descrOficina={this.props.descrOficina} listaOf={this.props.listaOf}
                              empresa={this.props.empresa} args={argsAdd} errors={errorAdd}/>}
                              
            {showProcDX && <ProcDX2 styles={this.props.styles} list={lista} list1={lista1}
                              list2={lista2} handleLista={this.handleCiudadDpto}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel} handleLista4={this.handleClaseSub}
                              handleChange={this.handleChange}
                              argsSelDpto={argsAdd}/>}
          
            {showProcCliDX && <ProcCliDX2 styles={this.props.styles} list={lista} handleClickidLista={this.idLista}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA} args={argsAdd}/>}
            {verCliDX && <VerCliDX2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  args={argsAdd} errors={errorAdd} idLista={idLista} argsBuscar={argsBuscar}
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} empresa={this.props.empresa}
                  permiteClose={permiteClose} comoAsigCargosAlCliente={this.props.comoAsigCargosAlCliente}/>}

            {showProcATOS && <ProcATOS2 styles={this.props.styles} list1={lista1} list3={this.props.list3}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                  empresa={this.props.empresa} descrTipoRec={this.props.descrTipoRec}
                  handleLista={this.handleCiudadDpto}
                  handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                  handleLista3={this.handleBarrioSel} handleChange={this.handleChange}
                  argsSelDpto={argsAdd}/>}

            {showProcAT && <ProcAT2 styles={this.props.styles} list1={lista1} list3={this.props.list3}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                  handleLista={this.handleCiudadDpto}
                  handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                  handleLista3={this.handleBarrioSel} handleChange={this.handleChange}
                  argsSelDpto={argsAdd}/>}

            {showProcCS && <ProcCS2 styles={this.props.styles} list1={lista1} list3={this.props.list3}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                  handleLista={this.handleCiudadDpto}
                  handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                  handleLista3={this.handleBarrioSel} handleChange={this.handleChange}
                  argsSelDpto={argsAdd}/>}

            {showProcEC && <ProcEC2 autorizacUA={this.props.autorizacUA} codigoCiudadUA={this.props.codigoCiudadUA}
                              codigoDptoUA={this.props.codigoDptoUA} styles={this.props.styles}
                              list1={lista1} list2={lista2} list3={lista3} list7={lista7}
                              listaCF={this.props.listaCF}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel} handleLista4={this.handleClaseSub}
                              argsSelDpto={argsAdd}
                              handleClickRegr={this.showProc} empresa={this.props.empresa}/>}

            {/* {showProcEC && <ProcEC2 styles={this.props.styles} list1={lista1} list3={this.props.list3}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                  handleLista={this.handleCiudadDpto}
                  handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                  handleLista3={this.handleBarrioSel} handleChange={this.handleChange}
                  argsSelDpto={argsAdd}/>} */}

              {showProcAdm && <ProcAdm2 styles={this.props.styles}/>}

              {showCambContr && <ProcAdmCC autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                  args={argsAdd}/>}
              {showCliNu && <ProcAdmClNu autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showCliUpd && <ProcAdmClUpd autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showOSDX && <ProcAdmOSDX autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showOSSC && <ProcAdmOSSC autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showTC && <ProcAdmTC autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles} lista4={this.props.lista4}/>}

              {handleClickArchCarAdic &&  <ProcAdmCA autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
              {showArchNC && <ProcAdmNC autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showArchAjNeg && <ProcAdmAjNeg autorizacUA={this.props.autorizacUA} empresa={this.props.empresa}
                  styles={this.props.styles}/>}
              {showArchAjPos && <ProcAdmAjPos autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
              {showArchClNd && <ProcAdmClNd autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}

          </div>
        </div>
      </div>
    )
  }
}

export default compose(  
  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),
  graphql(queries.query.allClientes, {name:'allClientes2', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes2', options: (props) => {return {variables: {contrato: "XYZ321", orden: '-_id'}}}}),
  
  graphql(queries.query.allPagoRtes, {name:'allPagoRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {numeroRT: "XYZZYX"}}]`}}}}),

  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createRangoFact, {name:'createRangoFact'}),
  graphql(queries.mutation.editRangoFact, {name:'editRangoFact'}),
  graphql(queries.mutation.deleteRangoFact, {name:'deleteRangoFact'}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allClasesServ, {name:'allClasesServ'}),

  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.createPagoClientes, {name:'createPagoClientes'}),
  graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),

  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  // graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),
  
  graphql(queries.query.allProcDX, {name:'allProcDX', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.createAjuste, {name:'createAjuste'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeProc)
